import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white theme-transition relative">
      <Navbar />
      <div className="flex flex-1 pt-16">
        <Sidebar />
        <main className="flex-1 px-4 py-6 md:px-6 lg:px-8 w-full max-w-5xl mx-auto overflow-hidden relative z-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;